import { useMutation }  from '@tanstack/react-query'
import { useNavigate }  from 'react-router-dom'
import { authService }  from '@services'
import { useAuthStore } from '@store/authStore'
import { queryClient }  from '@providers/QueryProvider'
import { ROUTES }       from '@constants/routes'

/**
 * useLogoutMutation — calls logout endpoint, clears all cache + store state.
 */
export function useLogoutMutation() {
  const storeLogout = useAuthStore((s) => s.logout)
  const navigate    = useNavigate()

  return useMutation({
    mutationFn: () => authService.logout(),
    onSettled: () => {
      // Always clear local state, even if the server request fails
      storeLogout()
      queryClient.clear()
      navigate(ROUTES.AUTH.LOGIN, { replace: true })
    },
  })
}
